export default "__VITE_ASSET__9ffd1172__"